<template>
  <div data-app>
    <v-card>
      <v-card-title>
        Source Types
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="sourceTypeCollection"
        :search="search"
        :sort-by="['name']"
        @click:row="handleClickItem"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <SourceTypeModalForm
              :modalData="modalData"
              :editedItem="editedItem"
              :permissions="permissions"
              :statuses="statuses"
              @closeModalForm="handleCloseModalForm"
              @saveModalForm="handleSaveModalForm"
            ></SourceTypeModalForm>
            <v-spacer></v-spacer>

            <!-- <v-checkbox
              v-model="showAll"
              label="Active departments"
            ></v-checkbox> -->

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- <template v-slot:item.status="{ item }">
          <span v-if="statuses.system">{{
            statuses.companySettings.department[item.status].value
          }}</span>
        </template> -->
        <template v-slot:item.actions="{ item }">
          <!-- <router-link
            :to="`/sales/sourceTypes/${item.id}`"
            v-if="permissionCan('view')"
          >
            <v-icon small class="mr-2"> mdi-pencil </v-icon>
          </router-link> -->
          <v-icon
            v-if="permissionCan('delete')"
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ApiService from "@/core/services/api.service";
import SourceTypeModalForm, { initialFormData } from "./SourceTypeModalForm";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";

export const ENDPOINT = "sales/sourceType/";

export default {
  name: "sourceTypes",
  components: { SourceTypeModalForm },
  mixins: [listModelsMixins],
  data() {
    return {
      showAll: false,
      search: "",
      collection: [],
      permissions: [],
      headers: [
        {
          text: "Source Types",
          value: "name",
        },
        // { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      modalData: {
        dialog: false,
        loading: false,
        // editedItem: Object.assign({}, initialFormData),
      },
      editedItem: Object.assign({}, initialFormData),

      dialogDelete: false,
      routePath: "/sales/sourceTypes/",
    };
  },

  computed: {
    ...mapGetters(["sourceTypeCollection", "statuses"]),
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // showAll() {
    //   if (this.companyTypeCollection.length > 0) {
    //     this.filterCollection(this[DEPARTMENT_COLLECTION]);
    //   }
    // },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
    sourceTypeCollection(val) {
      this.filterCollection(val);
    },
  },

  methods: {
    ...mapActions(["fetchSourceType"]),
    editItem(id) {
      ApiService.get(ENDPOINT + id)
        .then(({ data }) => {
          this.editedItem = Object.assign({}, data);
          this.modalData.dialog = true;
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      ApiService.delete(ENDPOINT + this.editedItem.id)
        .then(() => {
          this.fetchSourceType();
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
      this.closeDelete();
    },

    handleCloseModalForm() {
      this.modalData.dialog = false;
      this.fetchSourceType();
      this.editedItem = initialFormData();
      if (this.$route.name !== "sourceType")
        this.$router.push({ name: "sourceTypes" });
    },

    closeDelete() {
      this.editedItem = Object.assign({}, initialFormData);
      this.dialogDelete = false;
    },

    // handleSaveModalForm() {
    //   this.handleCloseModalForm();
    // },

    filterCollection(coll) {
      if (!this.showAll) {
        this.collection = coll;
      } else {
        this.collection = coll.filter((item) => {
          return item.status == 1;
        });
      }
    },

    // handleClickItem(item) {
    //   if (this.permissionCan("view") && !this.dialogDelete) {
    //     this.$router.push(`/sales/sourceTypes/${item.id}`);
    //   }
    // },

    permissionCan(action) {
      return this.permissions.find(
        (x) => x.name == "sales.sourceType." + action
      );
    },

    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("sourceType") > -1
        );
      }
    },
  },

  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Source Type" }]);
    this.fetchSourceType();

    this.setPermissions();
  },
};
</script>
